
import {
  getStepsToJoinCampaign,
  JOIN_CAMPAIGN_STEP_TYPE,
} from '../ui/StepsToJoinCampaign/getStepsToJoinCampaign';
import type {
  StepsToJoinCampaignStep,
} from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import StepsToJoinCampaign from '../ui/StepsToJoinCampaign/StepsToJoinCampaign';
import { GateIoLink } from './GateIoLink';

const stepsToJoinFoxsyCampaign: StepsToJoinCampaignStep[] = [
  ...getStepsToJoinCampaign([
    JOIN_CAMPAIGN_STEP_TYPE.SIGNUP_AND_VERIFY_EMAIL,
    JOIN_CAMPAIGN_STEP_TYPE.LINK_SOLANA_WALLET,
    JOIN_CAMPAIGN_STEP_TYPE.REGISTER_ON_GOODCRYPTOX,
  ]),
  {
    type: JOIN_CAMPAIGN_STEP_TYPE.CONNECT_YOUR_GATE_IO,
    id: 'connect-gate-io-account',
    title: (
      <>
        Connect your <GateIoLink /> account with an API key
      </>
    ),
    href: 'https://goodcrypto.app/faq/api-keys-faq/',
    buttonLabel: 'Connect Now',
  },
  {
    type: JOIN_CAMPAIGN_STEP_TYPE.TRADE_FOXSY_USDT,
    id: 'trade-foxsy-usdt',
    title: (
      <>
        Trade FOXSY/USDT on <GateIoLink /> via GoodCryptoX
      </>
    ),
    href: 'https://app.goodcrypto.app/trade/GTIO0/FOXSYUSDT/buy',
    buttonLabel: 'Trade Now',
  },
  {
    id: 'check',
    title: 'Check the leaderboard & keep trading for bigger rewards!',
  },
];

const StepToJoinFoxsyCampaign = () => {
  return (
    <StepsToJoinCampaign
      headerTitle="🎯 How to Participate?"
      steps={stepsToJoinFoxsyCampaign}
      className="story-prose-none"
    />
  );
};

export default StepToJoinFoxsyCampaign;
